document.addEventListener('DOMContentLoaded', () => {

  /* ---------- Mobile nav ---------- */
  const navToggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('.nav');
  if (navToggle && nav) {
    navToggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ---------- Gallery thumbnails ---------- */
  const mainImg = document.querySelector('[data-gallery-main]');
  const thumbs = document.querySelectorAll('[data-gallery-thumb]');
  thumbs.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbs.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (mainImg) {
        const src = btn.getAttribute('data-full') || btn.querySelector('img').src;
        mainImg.src = src;
      }
    });
  });

  /* ---------- Quantity stepper ---------- */
  const qtyInput = document.querySelector('[data-qty-input]');
  document.querySelectorAll('[data-qty-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      let val = parseInt(qtyInput.value, 10) || 1;
      val += btn.getAttribute('data-qty-btn') === 'inc' ? 1 : -1;
      if (val < 1) val = 1;
      qtyInput.value = val;
      syncStickyPrice();
    });
  });

  /* ---------- Variant selection swaps main image ---------- */
  document.querySelectorAll('[name="variant"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const img = radio.getAttribute('data-image');
      if (img && mainImg) mainImg.src = img;
    });
  });

  /* ---------- Add to cart (demo behaviour) ---------- */
  /*
    NOTA PARA INTEGRAR EN SHOPIFY:
    Este botón simula el añadido al carrito para la demo estática.
    Al convertir esta página en una sección/plantilla de producto de Shopify,
    sustituye este manejador por un <form action="/cart/add" method="post">
    o por una llamada a la Ajax Cart API de Shopify:
      fetch('/cart/add.js', { method:'POST', body:new FormData(form) })
    usando el id de la variante seleccionada.
  */
  const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
  const toast = document.querySelector('[data-toast]');
  let toastTimer;
  function showToast(msg){
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  }
  addToCartButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const qty = qtyInput ? qtyInput.value : 1;
      showToast(`Añadido al carrito (${qty} ud.) — conecta el checkout de Shopify para finalizar la compra`);
    });
  });

  /* ---------- Sticky mobile bar ---------- */
  const stickyBar = document.querySelector('[data-sticky-bar]');
  const buybox = document.querySelector('[data-buybox]');
  if (stickyBar && buybox && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(buybox);
  }
  function syncStickyPrice(){ /* placeholder for future price-by-qty logic */ }

  /* ---------- Sticky bar CTA scrolls to buybox ---------- */
  document.querySelectorAll('[data-scroll-to-buybox]').forEach(el => {
    el.addEventListener('click', (e) => {
      if (buybox) {
        e.preventDefault();
        buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

});
